import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import './theme/theme.css';
import App from './App';
import { patchFetchForPreview } from './lib/preview';
import reportWebVitals from './reportWebVitals';
import { CampaignThemeProvider } from './theme/CampaignThemeProvider';
import { StrapiFAQProvider } from './contexts/StrapiFAQContext';
import { AuthProvider } from './contexts/AuthContext';
import { initGA } from './lib/analytics';

// Disable browser scroll restoration IMMEDIATELY before any React code runs
// This prevents the browser from restoring scroll position on SPA navigation
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Initialize Google Analytics
initGA();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Every polling hook already bypasses HTTP caching (no-store) on its own
      // schedule; React Query's own staleness window shouldn't add a second,
      // competing freshness gate on top of that.
      staleTime: 0,
    },
  },
});

// Always install the preview fetch patch; it only activates when preview is enabled or ?preview=1 is present
patchFetchForPreview();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <StrapiFAQProvider>
          <CampaignThemeProvider>
            <BrowserRouter>
              <AuthProvider>
                <App />
              </AuthProvider>
            </BrowserRouter>
          </CampaignThemeProvider>
        </StrapiFAQProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
